import DemoWrapper from "../../utils/DemoPageWrapper";
/* eslint-disable import/no-webpack-loader-syntax */
import Demo from "./demo.vue";
import DemoSource from "!!raw-loader!./demo.vue";

const config = {
  props: [
    {
      prop: "label",
      description: "switch标签文本",
      type: "String"
    },
    {
      prop: "size",
      description: "尺寸",
      type: "String",
      available: "small/default",
      default: "default"
    },
    {
      prop: "value",
      description: "check值（v-model）",
      type: "Boolean",
      required: "是"
    },
    {
      prop: "disabled",
      description: "是否为禁用状态",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "loading",
      type: "Boolean",
      description: "是否显示loading动画",
      default: "false"
    }
  ],
  methods: [],
  slots: []
};

export default DemoWrapper(Demo, DemoSource, config);
